
import { ResultData } from "@nt-portal/common-sdk";

import { AIPayloadItem, AIResult, DbInuseResult, TCMMasterGroup, TCMMasterGroupSearch, TCMMasterGroupService, TCMStatsItem } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { randomColor } from "../../../../common";

export interface TCMMasterGroupOptions extends ControllerOptions<TCMMasterGroup> {
    importMode?: string;
    mine?: boolean;
}

export const createTCMMasterGroup = (inObj: Partial<TCMMasterGroup>) => {
    let item: TCMMasterGroup = {
        groupNumber: "",
        groupId: 0,
        name: "",
        createdBy: "",
        color: randomColor(),
        category: undefined
    }
    return item;
}


export class ClientTCMMasterGroupService extends BaseClientService implements DataController<TCMMasterGroup> {

    private _service: TCMMasterGroupService;


    constructor() {
        super();
        this._service = new TCMMasterGroupService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMMasterGroupOptions): Promise<ResultData<TCMMasterGroup>> {
        let search: TCMMasterGroupSearch = {
            filter: options.filter ?? "",
            mine: options.mine ?? false
        }

        return await this._service.get(this.buildFetchParams(options), this.token, search);

    }
    public async getLookup(options: TCMMasterGroupOptions): Promise<ResultData<TCMMasterGroup>> {
        let search: TCMMasterGroupSearch = {
            filter: options.filter ?? "",
            mine: options.mine ?? false
        }

        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token, search);
        return data;
    }

    public async getById(options: TCMMasterGroupOptions): Promise<TCMMasterGroup | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMMasterGroupOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMMasterGroupOptions): Promise<TCMMasterGroup | TCMMasterGroup[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMMasterGroupOptions): Promise<TCMMasterGroup | TCMMasterGroup[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async clone(options: TCMMasterGroupOptions): Promise<TCMMasterGroup | TCMMasterGroup[] | null> {
        if (options.item && options.id)
            return await this._service.clone(options.id, options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async validateNumber(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateNumber(name, this.token, id)
    }

    public async import(options: TCMMasterGroupOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMMasterGroupOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

    // public async importContractBid(id: string, companyId: string, bid: TCMBid, file: File): Promise<any> {


    //     return await this._service.importContractBid(id, companyId, bid, file, this.token);

    // }

    public async stats(options: TCMMasterGroupOptions): Promise<TCMStatsItem[]> {
        if (options.id) {
            return await this._service.stats(this.token, options.id);
        }
        return []

    }
    public async genRule(options: TCMMasterGroupOptions, payload: AIPayloadItem[]): Promise<AIResult | null> {
        if (options.id) {
            let item = await this._service.genRule(options.id, this.token, payload);
            return item;
        }
        return null;
    }

     public async inUse(options: TCMMasterGroupOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        } else {
            throw new Error("ID is required for inUse check");
        }
    }

}